import React, { useEffect, useState } from "react";
import { api } from "../api";

/** Clé EA permanente pour l'input Analytics_API_Token de l'EA (ne dépend plus de la session). */
export const AnalyticsEaKey = ({ headers, basePath = "/admin/analytics" }) => {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`${basePath}/ea-key`, headers).then(({ data }) => setInfo(data))
      .catch((e) => setError(e.response?.data?.detail || "Impossible de charger la clé EA."));
  }, []); // eslint-disable-line

  const copy = async () => {
    try { await navigator.clipboard.writeText(info.key); } catch {
      const ta = document.createElement("textarea");
      ta.value = info.key; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const regenerate = async () => {
    if (!window.confirm("Régénérer la clé ? L'ancienne cessera immédiatement de fonctionner dans l'EA.")) return;
    setBusy(true); setError("");
    try { const { data } = await api.post(`${basePath}/ea-key/regenerate`, {}, headers); setInfo(data); }
    catch (e) { setError(e.response?.data?.detail || "Échec de la régénération de la clé."); }
    finally { setBusy(false); }
  };

  return (
    <div className="glass p-4 rounded-xl mb-4" data-testid="analytics-ea-key">
      <div className="text-sm font-semibold">🔑 Clé EA (input <span className="font-mono">Analytics_API_Token</span>)</div>
      <div className="text-xs text-zinc-400 mt-0.5 mb-2">
        Clé permanente : elle n'expire pas et reste valable même après une déconnexion.
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <code className="flex-1 min-w-[220px] p-2 rounded bg-black/40 font-mono text-xs text-cyan-300 break-all"
              data-testid="analytics-ea-key-value">{info?.key || "…"}</code>
        <button onClick={copy} disabled={!info} data-testid="analytics-ea-key-copy"
                className="btn-primary px-3 py-1.5 rounded-md text-xs disabled:opacity-40">
          {copied ? "✓ Copié" : "📋 Copier"}
        </button>
        <button onClick={regenerate} disabled={busy} data-testid="analytics-ea-key-regenerate"
                className="btn-ghost px-3 py-1.5 rounded-md text-xs disabled:opacity-40">
          {busy ? "…" : "♻️ Régénérer"}
        </button>
      </div>
      <div className="text-[11px] text-zinc-500 mt-2" data-testid="analytics-ea-key-last-used">
        Dernière utilisation par l'EA : {info?.last_used_at ? info.last_used_at.slice(0, 16).replace("T", " ") + " UTC" : "jamais"}
      </div>
      {error && <div className="text-[11px] text-red-400 mt-1" data-testid="analytics-ea-key-error">{error}</div>}
    </div>
  );
};
